import { client } from '../../utilities/api';
import { captureError } from '../../utilities/error';
import { alertConstants } from '../constants';
import { rtkApi } from '../rtk';

export const deleteAsset = (activityId, assetId) => async (dispatch) => {
  try {
    await client.deleteAsset(assetId);

    dispatch(
      rtkApi.util.invalidateTags([
        'Assets',
        { type: 'Assets', id: assetId },
        { type: 'Activity', id: activityId },
      ])
    );
  } catch (error) {
    captureError(error);
    dispatch({
      type: alertConstants.ALERT_ERROR,
      payload: {
        message: error.response?.data?.message ?? 'Unknown error',
      },
    });
  }
};
